import { Text } from '@/components/ui/Text';

export function QuoteTotal({
  totalPrice,
  isPromotionUsed,
}: {
  totalPrice: number;
  isPromotionUsed: boolean;
}) {
  return (
    <div>
      <div className='flex flex-col gap-[8px] md:flex-row'>
        <Text variant='h2-serif'>Membership Quote:</Text>

        <Text
          variant='h1'
          color={isPromotionUsed ? 'muted' : 'dark'}
          strike={isPromotionUsed}
        >
          ${totalPrice.toLocaleString()} annually
        </Text>
      </div>
    </div>
  );
}
